import { FC, InputHTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  children?: ReactNode;
  className?: string;
  error?: string;
  label: ReactNode;
}

export const InputWithFloatingLabel: FC<Props> = ({
  children,
  className = '',
  error,
  label,
  name,
  type = 'text',
  ...inputProps
}) => {
  return (
    <div
      className={classNames('input-with-floating-label', className, {
        filled: inputProps.value,
        withLabel: label,
      })}
    >
      {children || <input id={name} name={name} type={type} {...inputProps} />}
      <label htmlFor={name}>
        {label}
        {error && ` (${error})`}
      </label>
    </div>
  );
};
